import '../styles/PageGlobal.css';
import './ClientNewPage.css';
import React, { useState } from "react";

import { ClientService } from '../services/ClientService.js';

export default function ClientNewPage() {

  
  // 1. Basic Client Info
  const [form, setForm] = useState({
    societe1: '', societe2: '', 
    telephone: '', email: '',
    kbis: '', siret: '', siren: '',
   tvaIntraComm: '', 
     
  });

  

  

  // --- HANDLERS ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  
  

  // --- SAVE TO BACKEND ---
  const handleSave = async () => {
    try {
      const clientService = new ClientService();
      
      // Map everything to the Backend ClientDTO structure
      const payload = {
        societe1: form.societe1,
        societe2: form.societe2,
        telephone: form.telephone,
        email: form.email,             
        kbis: form.kbis,
        siret: form.siret,
        siren: form.siren,                
        tvaIntraComm: form.tvaIntraComm,    
        status: form.cont,            
        
       

       
      };

      await clientService.createClient(payload);
      alert("Client créé avec succès !");
      
      // Optional: Reset form or navigate back to list
    } catch (err) {
      console.error(err);
      alert("Erreur: " + err.message);
    }
  };

  return (
    <div className="containerMain client-new-container">
      <h1 className="client-new-title">Créer un Client</h1>
     
      
      <div className="client-new-form">
        {/* Section: Identité & Contact Principal */}
        <fieldset className="client-new-section">
          <legend>Identité & Contact</legend>
          <div className="client-new-grid client-new-grid-2">
            <div className="client-new-row"><label>Société 1 *</label><input name="societe1" value={form.societe1} onChange={handleChange} required /></div>
            <div className="client-new-row"><label>Société 2</label><input name="societe2" value={form.societe2} onChange={handleChange} /></div>
            <div className="client-new-row"><label>Email</label><input type="email" name="email" value={form.email} onChange={handleChange} /></div>
            <div className="client-new-row"><label>Téléphone *</label><input name="telephone" value={form.telephone} onChange={handleChange} required /></div>
          </div>
        </fieldset>

       
        {/* Section: Documents administratifs */}
        <fieldset className="client-new-section">
          <legend>Documents administratifs</legend>
          <div className="client-new-grid client-new-grid-3">
            <div className="client-new-row"><label>KBIS</label><input name="kbis" value={form.kbis} onChange={handleChange} /></div>
            <div className="client-new-row"><label>SIRET</label><input name="siret" value={form.siret} onChange={handleChange} maxLength={14} /></div>
            <div className="client-new-row"><label>SIREN</label><input name="siren" value={form.siren} onChange={handleChange} maxLength={9} /></div>
            <div className="client-new-row"><label>TVAIntraComm</label><input name="tvaIntraComm" value={form.tvaIntraComm} onChange={handleChange} /></div>
          </div>
        </fieldset>
      </div>

      

      <div className="client-new-footer">
        <button className="client-btn client-btn-blue" onClick={handleSave}>Enregistrer</button>
        <button className="client-btn client-btn-grey" onClick={() => console.log("Cancel")}>Annuler</button>
      </div>
    </div>
  );
}